<template>
    <div class="CloudClassroomProject_wrap">
      <el-page-header @back="goBack" ></el-page-header>
        <!-- 背景图 -->
        <div class="project_bgimg" :style="`background:url(${this.bannerInfo.backImg}) 0 0/100% 100% no-repeat`">
            <div class="project_title">{{bannerInfo.title}}</div>
            <div class="project_des">
                {{bannerInfo.description}}
            </div>
        </div>
        <!-- 内容 -->
        <div class="project_content">
            <div class="project_select">
              <div class="select">
                <i class="iconfont icon-shaixuan"></i>
                <span>&nbsp;筛选</span>
              </div>
              <div class="cheackbox">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                <div style="margin: 15px 0;"></div>
                <el-checkbox-group v-model="checkList" @change="handleCheckedItemChange">
                  <el-checkbox v-for="item in checkItems"  :key="item.userId" :label="item.userId">{{item.username}}</el-checkbox>
                </el-checkbox-group>
              </div>
              <!-- 搜索 -->
              <div class="flex-between">
                <div></div>
                <div class='project_serch'>
                    <el-input v-model='searchKey' @keyup.enter.native='getfilterItem' placeholder='文章标题关键字/词'
                              class='project_input'>
                        <el-button slot='suffix' round @click='getfilterItem' type='primary'>搜索</el-button>
                    </el-input>
                </div>
              </div>

            </div>
            <div v-for="column in columnList" :key="column.userId" class="one_block">
                <el-divider>{{column.username}}原创专栏</el-divider>
              <div class="selection_wrap flex-between">
                  <div></div>
                  <el-form  label-width="80px" class="selection">
                      <el-form-item label="排序:">
                          <el-select placeholder="请选择" @change="filterForm" v-model="sortType">
                              <el-option v-for="item in selectList" :key="item.id" :label="item.label" :value="item.id"></el-option>
                          </el-select>
                      </el-form-item>
                  </el-form>
              </div>
              <div v-for="item in column.articleList" :key="item.id" class="single_passage" @click="toArticleDetail(item.id)">
                  <div class="title_img">
                      <img :src="item.imageUrl" alt="" />
                  </div>
                  <div class="title_msg">{{item.title}}</div>
                  <div class="flex-between other_wrap">
                      <div>发布时间:{{item.createTime}}</div>
                      <div>阅读量:{{item.browseNum}}</div>
                  </div>
              </div>
            </div>
        </div>
        <div class="page_wrap">
            <el-pagination  layout="prev, pager, next" :page-size="5"  @current-change="filterForm" :current-page.sync="pages.currentPage" :total="pages.total"></el-pagination>
        </div>
    </div>
</template>

<script>
import { articleList, articlePublisher } from '../../../utils/api';

export default {
    data() {
        return {
            bannerInfo: {
                backImg: '',
                description: '',
                title: ''
            },
            selectList: [{
                id:0,
                label:'最晚发布'
            },{
                id:1,
                label:'最早发布'
            },{
                id:2,
                label:'浏览量'
          }],
          searchKey:'',
          sortType:0,
          pages:{
              currentPage:1,
              total:0
          },
          subjectId:this.$route.query.subjectId,
          isIndeterminate:false,
          checkAll: false,
          checkList:[],
          checkItems:[],
          columnList:[]
        };
    },
    mounted(){
      this.getfilterItem()
    },
    methods: {
        goBack(){
          this.$router.push('/cloudClassroom')
        },

        //获取筛选栏目
        getfilterItem(){
            articlePublisher({ subjectId: this.subjectId }).then(res => {
                this.checkItems = res.data.publisherList;
                this.bannerInfo.backImg = res.data.subject.bgUrl;
                this.bannerInfo.description = res.data.subject.description;
                this.bannerInfo.title = res.data.subject.title;
                this.checkList = this.checkItems && this.checkItems.map(item => item.userId);
                this.isIndeterminate = true;
                this.filterForm();
            }).catch(err=>{})
        },

        //筛选栏目
        filterForm(){
          let params = {
            keyword:this.searchKey,
            userIds:this.checkList,
            subjectId:this.subjectId,
            page:this.pages.currentPage,
            sort:this.sortType,
            size:5
          }
            articleList(params).then(res => {
                this.columnList = res.data.list;
                this.pages.total = res.data.totalCount;
            }).catch(err=>{})
        },

        //全选
        handleCheckAllChange(val) {
            this.checkList = val ? this.checkItems.map(item => item.userId) : [];
            this.isIndeterminate = false;
            this.filterForm()
        },

        //多选栏目发生改变
        handleCheckedItemChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.checkItems.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.checkItems.length;
            this.filterForm()
        },

        //单击查看当前栏目更多文章
        toMoreArticle(author,name){
            this.$router.push({path:'/articleCollection',query:{
              authorId:author,
              subjectId:this.subjectId,
              columnName:name
              }})
        },

         //查看文章详情
        toArticleDetail(id){
          this.$router.push({path:'/articleDetail',query:{
              articleId:id,
              subjectId:this.subjectId,
            }})
        },
    }

};
</script>

<style lang="scss" scoped>
.el-divider__text{
  font-size: 27px;
  font-weight: 600;
}
.page_wrap {
        height: 60px;
        line-height: 60px;
        text-align: center;
        margin-top: 100px;
    }
    .selection_wrap{
        width: 100%;
        text-align: right;
        margin-top: 100px;
        height: 40px;
        line-height: 40px;
        /deep/.el-form-item__label{
            color: #5277f7;
        }
        .selection {
            width: 270px;
        }
    }
.CloudClassroomProject_wrap {
    padding-top: 65px;
     color: #5277F7;
    .project_bgimg {
        width: 100%;
        height: 450px;
        overflow: hidden;
        text-align: left;
        .project_title {
            // width: 200px;
            height: 42px;
            font-size: 35px;
            letter-spacing: 2px;
            font-family: PingFang SC;
            font-weight: bold;
            line-height: 42px;
            margin-left: 150px;
            margin-top: 150px;
        }
        .project_des{
          width: 700px;
          height: 50px;
          font-size: 22px;
          font-family: PingFang SC;
          // font-weight: bold;
          line-height: 40px;
          text-align: justify;
          margin: 20px 150px;
        }
    }
    .project_content {
        width: calc(100% - 400px);
        margin-left: 200px;
        .project_select{
        width:100%;
        background: #FCFCFF;
        margin: 30px 0 150px 0;
        font-size: 18px;
        padding: 30px 40px;
        box-sizing: border-box;
        .cheackbox{
          margin: 20px 0px;
        }
        .project_serch{
          width: 250px;
          height: 50px;
          .el-button{
            position: relative;
            left: 5px;
          }
          /deep/ .el-input__inner {
            border-radius: 30px !important;
            // padding-right: 0px !important;
          }
        }
      }
         .one_block{
          width: 100%;
          margin-bottom: 100px;

             .single_passage {
            padding: 20px 40px 20px 25px;
            width: 100%;
            height: 230px;
            background: #fcfcff;
            box-shadow: 0px 3px 12px rgba(189, 204, 255, 0.3);
            color: #3C3C3C;
            box-sizing: border-box;
            align-items: center;
            display: flex;
            margin-top: 30px;
            .title_img {
                width: 22%;
                text-align: center;
                img {
                    height: 190px;
                    width: 100%;
                }
            }
            .title_msg {
                width: 53%;
                box-sizing: border-box;
                padding-left: 100px;
                text-align: left;
                font-size: 21px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #5277f7;
            }
            .other_wrap{
                align-self: flex-end;
                margin-bottom: 20px;
                width: 25%;
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #3c3c3c;
            }
        }
        .single_passage:hover{
            opacity: 0.9;
            background: #f3f3f5;
            cursor: pointer;
        }
        }
    }
}

/deep/ .el-checkbox{
  .el-checkbox__label{
    font-size: 18px;
  }
}

</style>
